import styled from 'styled-components';

export const PromotionsContainer = styled.div<{ $size: 'small' | 'large' }>`
  display: grid;
  grid-template-columns: ${({ $size }) =>
    ($size === 'small' && '1fr 1fr 1fr') || ($size === 'large' && '1fr 1fr ')};
  position: relative;
  gap: 20px;
  margin: 20px 0 0px 0;
  justify-content: space-between;
  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    gap: 0%;
  }
`;

export const ShopByCategoryContainer = styled.div`
  cursor: pointer;
  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 2%;
    margin-bottom: 3%;
  }
  background: white;
  padding: 15px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
`;

export const MyImage = styled.div<{ $size: 'small' | 'large' }>`
  position: relative;
  height: ${({ $size }) =>
    ($size === 'small' && 'calc(100vw * 0.2)') ||
    ($size === 'large' && 'calc(100vw * 0.3)')};
  > span img {
    border-radius: 4px;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    height: calc(100vw * 0.6);
  }
`;

export const CategoryNameWrapper = styled.div<{
  textAlign: 'left' | 'right' | 'center';
}>`
  text-align: ${({ textAlign }) => textAlign};
  margin-bottom: 10px;
`;

export const CategoryName = styled.div<{ fontSize: 'small' | 'large' }>`
  font-size: ${({ fontSize }) => (fontSize === 'small' ? '1.3rem' : '2rem')};
  font-weight: 450;
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 1.2rem;
    font-weight: 400;
    left: 5%;
    top: 5%;
  }
  color: black;
`;

export const ShopNowButton = styled.div`
  position: absolute;
  right: 4%;
  bottom: 7%;
  font-size: 1rem;
  padding: 2% 4%;
  background: ${({ theme }) => theme.palette.primary};
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;
